import { Direction } from "../engine/direction";

const SECTOR_DIRECTIONS: Direction[] = [
	Direction.W,
	Direction.NW,
	Direction.N,
	Direction.NE,
	Direction.E,
	Direction.SE,
	Direction.S,
	Direction.SW,
];

export function getPointedDirection(
	mousePixelX: number,
	mousePixelY: number,
	playerCenterPixelX: number,
	playerCenterPixelY: number,
): Direction {
	const deltaX = mousePixelX - playerCenterPixelX;
	const deltaY = mousePixelY - playerCenterPixelY;
	let angle = (Math.atan2(deltaY, deltaX) * 180) / Math.PI + 180;
	angle = (angle + 22.5) % 360;
	const sector = Math.floor(angle / 45);
	return SECTOR_DIRECTIONS[sector];
}
